import Translations from "@translate/components/OnboardingWizard/Paywall/OnboardingPaywallAnnualCard";
import React from "react";
import { cn } from "utils";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

interface OnboardingPaywallAnnualCardProps {
  annualPrice?: number;
  className?: string;
}

/** Figma `96138:32738` PricingCard — accent4 border + overlay10 fill. */
export const OnboardingPaywallAnnualCard: React.FC<
  OnboardingPaywallAnnualCardProps
> = ({ annualPrice, className }) => (
  <div
    className={cn(
      "w-full overflow-hidden rounded-2 border-2 border-border_accent4_solid bg-background_accent4_overlay10 p-3",
      className,
    )}
    data-testid="paywall-annual-card"
  >
    <p className="title_l text-content_primary">
      {I18n.t("Ed Complete Annual")}
    </p>
    <div className="mt-3 flex flex-wrap items-end gap-1.5">
      <span className="headline_regular_l text-content_accent4_primary">
        ${annualPrice != null ? annualPrice.toFixed(2) : "--"}
      </span>
      {annualPrice != null ? (
        <span className="body_s text-content_tertiary">
          {I18n.t("(≈$%{var0}/mo)", {
            var0: (annualPrice / 12).toFixed(2),
          })}
        </span>
      ) : null}
    </div>
  </div>
);
